import styled from 'styled-components'
import { media, highlight, colors } from 'styles'

import Button from 'components/Button/StyledButton'
import Filters from 'components/Filters/StyledFilters'
import SiteLogo from 'components/SiteLogo/StyledSiteLogo'
import UserPanel from 'components/Header/UserPanel/StyledUserPanel'
import NotificationsPanel from 'components/Header/NotificationsPanel/StyledNotificationsPanel'
import { StyledPhotofilter } from './Photofilter'

const StyledHeader = styled.header`
  display: flex;
  margin-bottom: 2rem;

  .header-right {
    flex: 1;
    display: flex;
    flex-flow: row-reverse wrap;
  }
  .header-panels-upgrade {
    display: flex;
    align-items: center;
  }
  .section-title {
    margin-top: 1.5rem;
  }
  ${SiteLogo} {
    display: none;
  }
  ${UserPanel} {
    margin-left: 0.5rem;
  }
  ${NotificationsPanel}, ${Button} {
    margin-left: 1rem;
  }

  ${Filters} {
    margin-right: auto;
    padding-top: 0.6rem;

    ${Button} {
      margin-left: 0;
    }
    & ~ ${UserPanel} .user-info {
      display: none;
    }
  }
  .chat-title {
    display: flex;
    align-items: center;
    margin-top: 0;
    a {
      text-decoration: none;
      color: inherit;
      padding: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  .button-cta {
    border: none;
    &:hover {
      background: ${p => highlight(0.1, p.theme.colors.cta)};
      transform: scale(1.05);
    }
  }

  ${media.tablet`
    .button-cta {
      font-size: 1.4rem;
      padding: 0.6rem 2rem;
    }
    .username.section-title {
      margin-left: calc(50% - 250px); /* tablet profile page max-width: 500px */
    }
  `}
  ${media.mobile`
    background: ${colors.main};
    flex-direction: row-reverse;
    padding-right: 5rem; /* space for hamburger - probably should be in header */

    .header-right {
      flex: none;
      .button-cta, ${UserPanel}, ${StyledPhotofilter} {
        display: none;
      }
    }

    ${SiteLogo} {
      display: inline-block;
      margin: auto;

      .text {
        color: ${colors.textMain};
      }
    }

    ${NotificationsPanel} {
      margin-left: 0;
    }

    ${Filters} { display: none; }

    .section-title {
      display: none;
    }
  `}
`

const HeaderBottom = styled.div`
  display: none;
  margin-bottom: 2rem;

  ${media.mobile`
    display: flex;
    flex-direction: column;

    .button-cta {
      margin-top: 1rem;
      width: 100%;
      padding: 1.2rem;
      text-align: center;
      font-size: 1.8rem;
      font-weight: 700;
    }

    .row {
      display: flex;
      width: 100%;
      margin-bottom: 2rem;
      &:nth-of-type(2){
        margin-bottom: 0;
      }
      &:empty {
        margin: 0;
      }
    }

    .filters-row {
      overflow: auto;
      margin-bottom: 0.6rem;
    }

    ${Filters} {
      justify-content: center;
    }

    .upgrade-filters-row {
      display: block;
    }
    .header-panels {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    ${StyledPhotofilter} {
      margin-top: 1rem;
      font-size: 1.5em;
      justify-content: center;
    }
  `}
`

export default StyledHeader
export { HeaderBottom }
